import {Alert, ConfigProvider} from 'antd';
import {ReactElement} from 'react';

import {gray2, gray4, gray7} from '../../../../../../css/var-export.scss';
import {Locale} from '../../../../../../provider/locale/localization';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';

export type HeaderAlertPropsType = {
    messageStringKey: LangKeyType;
    linkStringKey: LangKeyType;
    linkHref: string;
};

export function HeaderAlert({messageStringKey, linkStringKey, linkHref}: HeaderAlertPropsType): ReactElement {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Alert: {
                        colorInfo: gray7,
                        colorInfoBg: gray2,
                        colorInfoBorder: gray4,
                    },
                },
            }}
        >
            <Alert
                message={
                    <Locale
                        stringKey={messageStringKey}
                        valueMap={{
                            link: linkHref ? (
                                <a href={linkHref}>
                                    <Locale stringKey={linkStringKey} />
                                </a>
                            ) : (
                                ''
                            ),
                        }}
                    />
                }
                showIcon
                type="info"
            />
        </ConfigProvider>
    );
}
